// Enums para tipos de dia não funcionamento
export enum TipoDiaNaoFuncionamento {
  FERIADO = 'FERIADO',
  MANUTENCAO = 'MANUTENCAO',
  EVENTO = 'EVENTO',
  FECHAMENTO = 'FECHAMENTO'
}

// Interface principal para Dia Não Funcionamento
export interface DiaNaoFuncionamento {
  id: string;
  data: string; // ISO date string
  motivo: string;
  descricao?: string;
  ativo: boolean;
  recorrente: boolean;
  automatico: boolean; // Indica se foi importado automaticamente
  tipo: TipoDiaNaoFuncionamento;
  created_at: string; // ISO date string
  updated_at: string; // ISO date string
}

// Interface para criação de dia não funcionamento
export interface CreateDiaNaoFuncionamentoRequest {
  data: string; // ISO date string
  motivo: string;
  descricao?: string;
  ativo?: boolean;
  recorrente?: boolean;
  tipo: TipoDiaNaoFuncionamento;
}

// Interface para atualização de dia não funcionamento
export interface UpdateDiaNaoFuncionamentoRequest {
  data?: string; // ISO date string
  motivo?: string;
  descricao?: string;
  ativo?: boolean;
  recorrente?: boolean;
  tipo?: TipoDiaNaoFuncionamento;
}

// Interface para resposta da listagem
export interface DiaNaoFuncionamentoListResponse {
  dias: DiaNaoFuncionamento[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// Interface para verificação de data
export interface VerificacaoDataResponse {
  isDiaNaoFuncionamento: boolean;
  dia?: DiaNaoFuncionamento;
}

// Interface para estatísticas (como retornado pela API)
export interface DiaNaoFuncionamentoStatistics {
  totalDias: number;
  diasAtivos: number;
  diasInativos?: number;
  diasRecorrentes: number;
  diasAutomaticos?: number;
  porTipo: Record<string, number>;
}

// Interface para estatísticas (compatibilidade)
export interface DiaNaoFuncionamentoEstatisticas {
  totalDias: number;
  diasAtivos: number;
  diasRecorrentes: number;
  porTipo: Record<string, number>;
  proximosDias?: Array<{
    data: string;
    motivo: string;
    tipo: string;
  }>;
}

// Interface para estatísticas detalhadas
export interface DiaNaoFuncionamentoEstatisticasDetalhadas {
  geral: {
    total: number;
    ativos: number;
    inativos: number;
    recorrentes: number;
    automaticos?: number; // ✅ CORREÇÃO: Adicionada propriedade para feriados automáticos
    manuais?: number;
  };
  periodo: {
    esteAno: number;
    passados: number;
    futuros: number;
  };
  porTipo: Record<string, number>;
}

// Interface para filtros de busca
export interface DiaNaoFuncionamentoFilters {
  page?: number;
  limit?: number;
  tipo?: TipoDiaNaoFuncionamento;
  ativo?: boolean;
  data_inicio?: string;
  data_fim?: string;
}

// Interface para card de métrica no dashboard
export interface DiaNaoFuncionamentoMetricCard {
  title: string;
  value: number | string;
  change: string;
  bg: string;
  icon: React.ComponentType; // Lucide icon component
}

// Labels para tipos
export const TipoDiaNaoFuncionamentoLabels: Record<TipoDiaNaoFuncionamento, string> = {
  [TipoDiaNaoFuncionamento.FERIADO]: 'Feriado',
  [TipoDiaNaoFuncionamento.MANUTENCAO]: 'Manutenção',
  [TipoDiaNaoFuncionamento.EVENTO]: 'Evento',
  [TipoDiaNaoFuncionamento.FECHAMENTO]: 'Fechamento'
};

// Cores para tipos
export const TipoDiaNaoFuncionamentoCores: Record<TipoDiaNaoFuncionamento, string> = {
  [TipoDiaNaoFuncionamento.FERIADO]: 'bg-green-100 text-green-800',
  [TipoDiaNaoFuncionamento.MANUTENCAO]: 'bg-orange-100 text-orange-800',
  [TipoDiaNaoFuncionamento.EVENTO]: 'bg-blue-100 text-blue-800',
  [TipoDiaNaoFuncionamento.FECHAMENTO]: 'bg-red-100 text-red-800'
};

// Interface para sincronização de feriados
export interface SincronizacaoFeriadosResponse {
  success: boolean;
  importados: number;
  atualizados: number;
  erros?: string[];
  message?: string;
}

// Interface para feriado nacional (API externa)
export interface FeriadoNacional {
  data: string;
  nome: string;
  tipo: string;
}

// Interface para importação de feriados
export interface ImportacaoFeriadosResponse {
  success: boolean;
  feriados: FeriadoNacional[];
  total: number;
}

// Interface para API response genérica
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
} 